import { Clock3, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useStorefront } from "../../contexts/StorefrontContext";

export function StoreFooter() {
  const { store } = useStorefront();
  if (!store) return null;
  return (
    <footer className="store-footer">
      <div className="page-width footer-grid">
        <div className="footer-about">
          <div className="footer-mark">{store.storeName[0]}</div>
          <strong>{store.storeName}</strong>
          <p>{store.about}</p>
        </div>
        <div><h3>Shop</h3><Link to="/products">All products</Link><Link to="/track-order">Track order</Link><Link to="/cart">Your cart</Link></div>
        <div><h3>Information</h3><Link to="/about">About us</Link><Link to="/contact">Contact</Link><Link to="/delivery-policy">Delivery policy</Link><Link to="/privacy-policy">Privacy policy</Link><Link to="/terms">Terms</Link></div>
        <div className="footer-contact"><h3>Contact</h3><p><MapPin />{store.address}</p><p><Phone />{store.phone}</p><p><Mail />{store.email}</p><p><Clock3 />Open daily</p></div>
      </div>
      <div className="footer-bottom page-width"><span>© {new Date().getFullYear()} {store.storeName}</span><span>Secure Cash on Delivery ordering</span></div>
    </footer>
  );
}
